import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#004c7f"};
  font-size: 14px;
  font-weight: bold !important;
  padding-left: ${(props) => props.paddingLeft ?? "20px"};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  font-weight: normal;
`;

export const DescriptionData = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 30px;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;

export const FlexRowLi = styled.div`
  display: flex;
  position: relative;
  left: -18px;
`;
